import axios from "axios";


export const fetchEstimator = (data) => {
  return axios
  .post(
    process.env.REACT_APP_API_URL + '/api/v1/estimator/cscalcs',
    data,  {
      headers: {
        "Content-Type": "application/json",
      }
    }
  )
}